import { render } from "./SegmentsProfileCard.vue?vue&type=template&id=0972a432&scoped=true"
import script from "./SegmentsProfileCard.vue?vue&type=script&lang=js"
export * from "./SegmentsProfileCard.vue?vue&type=script&lang=js"

import "./SegmentsProfileCard.vue?vue&type=style&index=0&id=0972a432&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0972a432"]])

export default __exports__